import axios from "axios";
import { API_URL } from "../../../config.tsx";

/**
 * Запрос всех каталогов автомобиля
 * @returns
 */
export const allCarCatalogsRequest = (brandId: string, ssd?: string) => {
    return axios.get(`${API_URL}/all_car_catalogs?brandCode=${brandId}${ssd ? `&ssd=${ssd}` : ''}`, {
        withCredentials: true,
    }).then(response => response.data);
};
